import { UpdateOrganizationDto } from '../../core/models/dtos/UpdateCustomerDto'
import { UpdateCustomerBody } from './bodies/UpdateCustomerBody'

export function mapFromUpdateOrganizationDto(dto: UpdateOrganizationDto): UpdateCustomerBody {
  return { ...dto } as UpdateCustomerBody
}